import type { MouseEventHandler } from 'react';

import type { UIResolvedContentReference } from './types';

/**
 * Get navigation props from a ref.
 */
export function useContentRefNavigationProps(
    ref: UIResolvedContentReference | null,
    props?: {
        onClick?: MouseEventHandler;
    }
): {
    href?: string;
    onClick?: MouseEventHandler;
} {
    if (!ref) {
        return {};
    }

    return {
        href: ref.href,
        onClick: (event) => {
            props?.onClick?.(event);

            if (event.isDefaultPrevented()) {
                return;
            }

            event.preventDefault();

            if (event.metaKey || event.ctrlKey) {
                window.open(ref.href, '_blank');
                return;
            }

            ref.open();
        },
    };
}
